import * as React from 'react'
import * as ReactDOM from 'react-dom'
import styled from 'styled-components'
import ScrollableAnchor from 'react-scrollable-anchor'
import { goToAnchor, configureAnchors  } from 'react-scrollable-anchor'

const Background = styled.div`
    &.active{
        background-image: url( ${(props) => props.theme.image.url});
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
        
        &:after,&:before{
            display: none !important;
        }
        .other-donated__item-heading{
            padding-right: 0px !important;
            margin-left: 32px !important;
            @media screen and (max-width: 560px) { 
                margin-left: 0px !important;
            }
        }
        .other-donated__item-content{
            display: block !important;
            margin-top: 24px;
            padding-left: 58px;
            @media screen and (max-width: 767px) { 
                padding-left: 0px;
            }
        }
    }
`
class OtherDonateItem extends React.Component {

    constructor(props) {
        super(props)
        let {index} = this.props
        let {other_donate_title_content,other_donate_title_item,other_donate_title_image} = props.data;
        this.state = {
            title : other_donate_title_item,
            content  : other_donate_title_content,
            imageBg:  other_donate_title_image,
            index: index,
            click:  0,
        }
        this.handleTabClick = this.handleTabClick.bind(this)
    }

    handleTabClick = () =>{
        let handleClickTab = this.props.handleClickTab;
        let {click,index} = this.state
        handleClickTab(index)
        configureAnchors({offset: -150, scrollDuration: 500})
        goToAnchor('section'+index, true)
    }

    render() {        
        
        let {title, content, imageBg} = this.state;
        let {isOpen, index} = this.props
        let classActive = isOpen ? 'active' : '';
        Background.defaultProps = {
            theme: {
                image: imageBg,
            },
        }
        return (
            <Background className={`other-donated__item ${classActive}`}>
                <div onClick={this.handleTabClick} className="other-donated__item-heading">
                <i className={`plug-to-minus-icon ${classActive}`}></i>  {title}
                </div>
                <ScrollableAnchor id={'section'+index}>
                    <div className="other-donated__item-content ecf-wp-editor" 
                        dangerouslySetInnerHTML={{
                            __html: content,
                        }}
                    />
                </ScrollableAnchor>
            </Background>
        )
    }
}   

export default OtherDonateItem;